import { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import InputText from '../../components/common/InputText'
import Button from '../../components/common/Button'
import { NavContext } from '../../context/global_context'
import { getSessionStorageData } from '../../utils/SessionStorage'
import { createSearchParams } from 'react-router-dom'
import UsageReport from '../../components/usage_report'

const UsageReportPage = () => {
  const [state, dispatch] = useContext(NavContext)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Usage Report',
        sub_header: 'Can be see activity logs here',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  return <UsageReport />
}

export default UsageReportPage
